var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-upload',{ref:"fileUpload",attrs:{"multiple":true,"drop-directory":true,"size":16 * 1024 * 1024},on:{"input-file":_vm.inputFile}},[_c('img',{staticClass:"img-responsive d-inline-block",attrs:{"src":require("@/assets/img/messenger-picture.svg"),"height":"20px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }